import { VLine } from '@ui/components/Line';
import { NoSSR } from '@ui/components/NoSSR';
import { PercentageSplitLine } from '@ui/components/PercentageSplitLine';
import { StatAmountUsd, StatLabel } from '@ui/components/Stats';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { Text, TextProps } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';
import { Box, Flex, FlexProps, HStack } from 'styled-system/jsx';

import { useOpenInterest } from '../../../../hooks/trade/useOpenInterest';

export const OpenInterestsDesktop = (p: FlexProps) => {
  const { t } = useTranslation();
  const tradingPair = useTradingPair((v) => v.useTradingPair());
  const { longRatio, longOIUsd, shortOIUsd } = useOpenInterest(tradingPair);

  const maxLongOiUsdBuffered = tradingPair.maxLongOiUsdBuffered;
  const maxShortOiUsdBuffered = tradingPair.maxShortOiUsdBuffered;

  return (
    <Flex {...p}>
      <Flex direction="column" mr={1} justifyContent="between">
        <StatLabel>{t('common.Open Interests(L)', 'Open Interest (L)')}</StatLabel>
        <HStack mt={0.5} gap={1}>
          <NoSSR>
            <StatAmountUsd
              as="span"
              opts={{ kmb: true }}
              value={longOIUsd}
              data-cy={`LongOIUsd-${tradingPair.pairName}`}
              data-cy-value={longOIUsd}
            />
            <Text textStyle="numbers.small" color="v2.text.subtle">{'/'}</Text>
            <StatAmountUsd
              as="span"
              opts={{ kmb: true }}
              value={maxLongOiUsdBuffered}
              data-cy={`maxLongOiUsdBuffered-${tradingPair.pairName}`}
              data-cy-value={maxLongOiUsdBuffered}
            />
          </NoSSR>
        </HStack>
      </Flex>
      <VLine h="full" />
      <Flex direction="column" justifyContent="center">
        <StatLabel>{t('common.Open Interests(S)', 'Open Interest (S)')}</StatLabel>
        <HStack mt={0.5} gap={1}>
          <NoSSR>
            <StatAmountUsd
              as="span"
              opts={{ kmb: true }}
              value={shortOIUsd}
              data-cy={`ShortOIUsd-${tradingPair.pairName}`}
              data-cy-value={shortOIUsd}
            />
            <Text textStyle="numbers.small" color="v2.text.subtle">{'/'}</Text>
            <StatAmountUsd
              as="span"
              opts={{ kmb: true }}
              value={maxShortOiUsdBuffered}
              data-cy={`maxShortOiUsdBuffered-${tradingPair.pairName}`}
              data-cy-value={maxShortOiUsdBuffered}
            />
          </NoSSR>
        </HStack>
      </Flex>
    </Flex>
  );
};
